import { render, staticRenderFns } from "./IdeaHeader.vue?vue&type=template&id=312a9b17&"
import script from "./IdeaHeader.vue?vue&type=script&lang=js&"
export * from "./IdeaHeader.vue?vue&type=script&lang=js&"
import style0 from "./IdeaHeader.vue?vue&type=style&index=0&id=312a9b17&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports